<nav [style]="'margin-left:' + 15 * heading.nestingLevel + 'px'" class="nav nav-pills flex-column">
  <a [fragment]="heading.id" class="nav-link" routerLink="." skipLocationChange>{{ heading.title }}</a>

  @for (child of heading.children; track child) {
    <app-calculation-form-sidebar-heading
    [heading]="child"></app-calculation-form-sidebar-heading>
  }

</nav>